import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC } from 'react';

const useStyles = makeStyles((theme: any) => ({
  field: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(0.75),
  },
  label: {
    flexShrink: 0,
    fontSize: '0.75rem',
    color: theme.palette.primary.light,
  },
  value: {
    minWidth: 0,
    textAlign: 'right',
    fontSize: '0.8125rem',
    color: theme.palette.primary.darker,
    overflowWrap: 'anywhere',
  },
}));

type FieldRowProps = {
  label: string;
  value: React.ReactNode;
};

const FieldRow: FC<FieldRowProps> = ({ label, value }) => {
  const classes = useStyles();
  return (
    <Box className={classes.field}>
      <Typography component="span" className={classes.label}>
        {label}
      </Typography>
      <Typography component="span" className={classes.value}>
        {value}
      </Typography>
    </Box>
  );
};

export default FieldRow;
